import { type App } from "vue";

import LanguageSwitcher from "@/components/language-switcher.vue";
import ThemeToggle from "@/components/theme-toggle.vue";
import SmallArrowRightIcon from "@/components/small-arrow-right-icon.vue";
import ArrowRightIcon from "@/components/arrow-right-icon.vue";
import OnlsTitle from "@/components/onls-title.vue";
import OnlsTitleBack from "@/components/onls-title-back.vue";
import SlideContentTable from "@/components/slide-content-table.vue";
import ValidationProvider from "@/components/validation-provider.vue";

const components = {
  install: (app: App<Element>) => {
    app.component("ThemeToggle", ThemeToggle);
    app.component("SmallArrowRightIcon", SmallArrowRightIcon);
    app.component("ArrowRightIcon", ArrowRightIcon);
    app.component("LanguageSwitcher", LanguageSwitcher);
    app.component("OnlsTitle", OnlsTitle);
    app.component("OnlsTitleBack", OnlsTitleBack);
    app.component("SlideContentTable", SlideContentTable);
    app.component("ValidationProvider", ValidationProvider);
  },
};

export { components };
